import { maxNameLength } from "src/common/rxName";
import { zId } from "src/types";
import { zSidLabel } from "src/types/ZSidLabel";
import { z } from "zod";

import {
  zExtensionFormBinding,
  zObjectExtensionBinding,
} from "../extensionBindings/ZExtensionBinding";
import { zRoleAccess } from "../permissions/ZRoleAccess";
import { zSysDataHistory } from "../sysData/ZSysData";

export const zClassifier = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z.string().max(maxNameLength),
  description: z.string().nullish(),
  displayAttribute: zSidLabel.nullish(),
  permissions: zRoleAccess
    .array()
    .nullish()
    .describe("Права доступа для ролей"),
  schemas: zSidLabel.array().nullish(),
  canCreate: z
    .boolean()
    .optional()
    .describe("Текущий пользователь может создавать новые классы"),
  extensions: zObjectExtensionBinding.array().nullish(),
  ...zSysDataHistory.shape,
});

export type ZClassifier = z.infer<typeof zClassifier>;

export type ClassifierFilters = { text?: string };

export const zClassifierCard = zClassifier
  .pick({
    name: true,
    description: true,
    permissions: true,
  })
  .extend({
    schemas: zSidLabel.nullish(),
    displayAttributeId: zId.nullish(),
    extensions: zExtensionFormBinding.array().nullish(),
  });

export type ZClassifierCard = z.infer<typeof zClassifierCard>;
